module.exports = __webpack_public_path__ + "media/images/flags/4x3/jpn-4c804454d98160571c7843b4d4f73f27.svg";